import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import ButtonFilter from "./ButtonFilter";

export default observer(function UsedFilter(){
    const { AccordionStore, LanguageStore } = useStore();
    const { setFilteredUsed, filteredUsed } = AccordionStore;
    const { currentLanguageMessages } = LanguageStore;

    return (
        <ButtonFilter
            title={currentLanguageMessages.AccordionsPage.Filter.Condition.title}
            filteredValue={filteredUsed}
            setFilteredValue={setFilteredUsed}
            attributeName={'used'}
            buttonObjects={[
                { value: false, imgAlt: currentLanguageMessages.AccordionsPage.Filter.Condition.new, imgBorderRadius: '0' },
                { value: true, imgAlt: currentLanguageMessages.AccordionsPage.Filter.Condition.used, imgBorderRadius: '0' },
            ]}
        />
    )
})